<template>
<div id="login">
    <div class="lgWrapper reg limiter container-login100"  style="background-image: url('static/bg-01.jpg');">
        <div class="wrap-login100">
                <span class="login100-form-logo p-b-34">
                    <img src="/static/logo_login.png" width="386" height="234"/>
                </span>
                <span class="login100-form-title p-b-34 p-t-100">
                    Đăng ký
                </span>
                    <span v-if="error_message != ''" class="message-error text-yellow">{{error_message}}</span>
                    <ul class="lgForm">
                        <li class="username">
                            <input type="email" name="email" v-model="model.email" class="form-control" v-bind:class="{'oee-error' : errors.has('email')}" v-validate="'required|email'" placeholder="Email" />
                        </li>
                        <li class="otherfield">
                            <input type="text" name="fullname" v-model="model.fullname" class="form-control" v-bind:class="{'oee-error' : errors.has('fullname')}" v-validate="'required'" placeholder="Họ và tên" />
                        </li>
                        <li class="otherfield">
                            <input type="text" name="phonenumber" v-model="model.phone" class="form-control" v-bind:class="{'oee-error' : errors.has('phonenumber')}" v-validate="'required'" placeholder="Điện thoại" />
                        </li>
                        <li class="otherfield">
                            <input type="text" name="address" v-model="model.address" class="form-control" v-bind:class="{'oee-error' : errors.has('address')}" v-validate="'required'" placeholder="Địa chỉ" />
                        </li>
                        <li class="password">
                            <input type="password" name="password" v-model="model.password" class="form-control" v-bind:class="{'oee-error' : errors.has('password')}" v-validate="'required'" placeholder="Mật khẩu"  ref="password"/>
                        </li>
                        <li class="password">
                            <input type="password" name="repassword" v-model="model.repassword" class="form-control" v-bind:class="{'oee-error' : errors.has('repassword')}" v-validate="'required|confirmed:password'" placeholder="Nhập lại mật khẩu" data-vv-as="password"/>
                        </li>
                        <li>
                            <button type="button" @click="register" class="btn btn-login">Đăng ký</button>
                        </li>
                        <div class="row">
                            <div class="col-6">
                                <router-link to="/quen-mat-khau" replace class="fgLink fr">Quên mật khẩu?</router-link>
                            </div>
                            <div class="col-6">
                                <router-link to="/dang-nhap" replace class="fgLink fr align-right">Đăng nhập</router-link>
                            </div>
                        </div>
                    </ul>
                </div>
            </div>
        </div>
</template>

<script>
import { mapState } from "vuex";
import { sendSuccessNotice, sendErrorNotice } from '@/commons/utils';
export default {
    computed: {
        ...mapState({
            token: state => state.authentication.token,
            resData: state => state.authentication.resData,
        }),
    },
    data: () => ({
        loading: false,
        error_message: '',
        model: {
            email: '',
            password: '',
            fullname: '',
            phone: '',
            address: '',
            password: '',
        },
        snackbar: false
    }),
    watch: {
        resData() {
            if (this.resData && this.resData.status_code == 202) {
                this.error_message = this.resData.message ? this.resData.message : 'Có lỗi trong quá trình xử lý, vui lòng liên hệ tracuumavandon để được hỗ trợ.'
            } else if (this.token && this.token !== '') {
                window.getApp.$emit('APP_LOGIN_SUCCESS');
            }
            this.loading = false;
        }
    },
    methods: {
        register() {
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.$store.dispatch('authentication/register', this.model);
                }
            });            
        }
    }

};
</script>

<style lang="css" scoped>
.lgWrapper.reg {
    height: 600px;
}
#login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
}
.align-right{
  float: right;
}
</style>
